import CheckoutSteps from '@features/Checkout/components/CheckoutSteps';
import fetchSiteWideData from '@features/WordPress/graphql/handlers/fetch-site-wide-data';
import { getLayout } from '@features/Checkout/layouts/CheckoutLayout/CheckoutLayout';
import { ErrorBoundary } from 'react-error-boundary';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import ErrorFallback from '@features/Checkout/components/ErrorFallback';
import { captureException, setExtra } from '@sentry/nextjs';

export async function getStaticProps({ locale }) {
  const { generalOptions } = await fetchSiteWideData(locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'checkout',
        'account',
      ])),
      generalOptions,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: [
      '/checkout',
      '/checkout/membership',
      '/checkout/details',
      '/checkout/payment',
      '/checkout/confirmation',
    ],
    fallback: 'blocking',
  };
}

const CheckoutPage = () => {
  const { asPath } = useRouter();

  const handleCheckoutError = (error) => {
    setExtra('errorMessage', error);
    captureException(new Error('Checkout error'));
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
        localStorage.clear();
        window.location.reload(true);
      }}
      onError={handleCheckoutError}
    >
      <CheckoutSteps key={asPath} />
    </ErrorBoundary>
  );
};

CheckoutPage.getLayout = getLayout;

export default CheckoutPage;
